import FormView from 'js/views/user_novena/form';

export default class View extends FormView {}
